import axios from 'axios';

export default (catalogId) => {
  const promise = new Promise((resolve, reject) => {
    const params = catalogId !== undefined ? { catalog_id: catalogId } : {};
    axios
      .get(process.env.VUE_APP_API_ADMIN_LOCATION + 'discount-package-tiers', { params })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
